var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "product-tile link-text",
      attrs: {
        href: _vm.product.url,
        id: _vm.id,
        tabindex: "0",
        "aria-live": "polite"
      },
      on: { click: _vm.onClickTile }
    },
    [
      _c("div", { staticClass: "product-tile__images" }, [
        _c("div", [
          !_vm.loaded
            ? _c(
                "svg",
                {
                  staticClass:
                    "product-tile__img-main product-tile__img-main--placeholder",
                  attrs: { viewBox: "0 0 350 465", width: "100%" }
                },
                [
                  _c("rect", {
                    attrs: { x: "0", y: "0", width: "100%", height: "100%" }
                  })
                ]
              )
            : _vm._e(),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loaded,
                expression: "loaded"
              }
            ],
            staticClass: "product-tile__img-main",
            attrs: {
              src: _vm.imageCrop(
                _vm.imageSize(_vm.images.default, "350x465"),
                "center"
              ),
              alt: _vm.images.defaultAlt,
              srcset:
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "260x345"),
                  "center"
                ) +
                " 168w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "350x465"),
                  "center"
                ) +
                " 304w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "260x345"),
                  "center"
                ) +
                " 1.5x, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.default, "350x465"),
                  "center"
                ) +
                " 2x"
            },
            on: {
              load: function() {
                _vm.loaded = true
              }
            }
          }),
          _c("img", {
            staticClass: "product-tile__img-hover",
            attrs: {
              src: _vm.imageCrop(
                _vm.imageSize(_vm.images.hover, "350x465"),
                "center"
              ),
              alt: _vm.images.hoverAlt,
              srcset:
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "260x345"),
                  "center"
                ) +
                " 168w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "350x465"),
                  "center"
                ) +
                " 304w, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "260x345"),
                  "center"
                ) +
                " 1.5x, " +
                _vm.imageCrop(
                  _vm.imageSize(_vm.images.hover, "350x465"),
                  "center"
                ) +
                " 2x",
              loading: "lazy"
            }
          })
        ])
      ]),
      _c("div", { staticClass: "product-tile__static-text-content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "product-tile__vendor" }, [
            _vm._v(_vm._s(_vm.product.vendor))
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "product-tile__title" }, [
            _c("div", { staticClass: "product-tile-title" }, [
              _vm._v(_vm._s(_vm.staticProductTitle))
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "product-tile__price-container" }, [
            !_vm.isCallForPrice(_vm.product)
              ? _c(
                  "span",
                  {
                    staticClass: "product-tile__price",
                    class: _vm.onSale ? "product-tile__price--accent" : ""
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Now: ")
                    ]),
                    _vm._v(
                      _vm._s(_vm._f("moneyWithoutDecimals")(_vm.variant.price))
                    )
                  ]
                )
              : _c(
                  "span",
                  {
                    staticClass: "product-tile__price",
                    class: _vm.onSale ? "product-tile__price--accent" : ""
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Now: ")
                    ]),
                    _vm._v("Call For Price")
                  ]
                ),
            _vm.onSale && !_vm.isCallForPrice(_vm.product)
              ? _c("span", { staticClass: "product-tile__compare-price" }, [
                  _c("span", { staticClass: "visually-hidden" }, [
                    _vm._v("Was: ")
                  ]),
                  _vm._v(
                    _vm._s(
                      _vm._f("moneyWithoutDecimals")(
                        _vm.variant.compare_at_price
                      )
                    )
                  )
                ])
              : _vm._e(),
            _vm.addtlPriceText
              ? _c(
                  "span",
                  {
                    staticClass: "product-tile__additional-price-text",
                    style: { color: _vm.addtlPriceTextColor }
                  },
                  [_vm._v(_vm._s(_vm.addtlPriceText))]
                )
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _vm.promoText
            ? _c(
                "div",
                {
                  staticClass: "product-tile__promotional-text",
                  style: { color: _vm.promoTextColor }
                },
                [_vm._v(_vm._s(_vm.promoText))]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }